import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { PropertySetsDialogActionsComponent } from '../property-sets-dialog-actions/property-sets-dialog-actions.component';
import { PropertySetRecordsComponent } from './property-set-records/property-set-records.component';
import { PropertySetSummaryComponent } from './property-set-summary/property-set-summary.component';
import { PropertySetFormComponent } from './property-set-form/property-set-form.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { PropertySetComponent } from './property-set.component';
import { QuarterSelectorModule, TableComponent, TableTitleComponent } from '@cbre/components';
import { MatButtonModule } from '@angular/material/button';
import { PropertySetStatisticalCellRendererComponent } from './property-set-records/property-set-statistical-cell-renderer-component/property-set-statistical-cell-renderer.component';
import { OpenInNewComponent } from './property-set-records/open-in-new/open-in-new.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MiqCatalogModule } from '@miq/catalog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SearchComponent } from './property-set-records/search-properties/search.component';
import { MatMenuModule } from '@angular/material/menu';
import { TableModule } from 'primeng/table';
import { PermissionTableComponent } from './permissions/permission-table/permission-table.component';
import { SelectModule } from 'primeng/select';
import { PropetySetConfirmationDialogComponent } from './propety-set-confirmation-dialog/property-set-confirmation-dialog.component';
import { PropertySetInfoDialogComponent } from './property-set-info-dialog/property-set-info-dialog.component';
import { HideControlsPipe } from './property-set-form/hide-controls.pipe';
import { HistoricalDetailComponent } from './historical-detail/historical-detail.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslationModule } from '@miq/utils';
import { TranslatePropertyTypePipe } from '@miq/utils/pipes';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatMenuModule,
    ReactiveFormsModule,
    PropertySetsDialogActionsComponent,
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    FormsModule,
    MiqCatalogModule,
    TableModule,
    SelectModule,
    TableComponent,
    TableTitleComponent,
    MatCheckboxModule,
    QuarterSelectorModule,
    TranslationModule,
    TranslatePropertyTypePipe,
  ],
  declarations: [
    PropertySetComponent,
    PropertySetSummaryComponent,
    PropertySetFormComponent,
    PropertySetRecordsComponent,
    PermissionsComponent,
    PermissionTableComponent,
    SearchComponent,
    PropertySetStatisticalCellRendererComponent,
    OpenInNewComponent,
    PropetySetConfirmationDialogComponent,
    PropertySetInfoDialogComponent,
    HideControlsPipe,
    HistoricalDetailComponent,
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [
    PropertySetComponent,
    PropertySetSummaryComponent,
    PropertySetFormComponent,
    PropertySetRecordsComponent,
    PropertySetStatisticalCellRendererComponent,
    PropetySetConfirmationDialogComponent,
    HideControlsPipe,
    HistoricalDetailComponent,
  ],
})
export class PropertySetModule {}
